import { Alert, Button, Card, CardContent, CardHeader, Stack, Typography } from '@mui/material'
import { useOperationsStore } from '@operations/AppProvider'
import { useTranslate } from '@tolgee/react'
import { DashboardTile, useMinimalsTheme } from '@tom-ui/ui'
import { useAsyncFetch } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
interface Props {
  visitId: number
  onViewClick: () => void
}

export const CraneSplitSummary = observer(({ visitId, onViewClick }: Props) => {
  const {
    equipmentsVesselVisitUIStore,
    tenantConfigStore,
    isCraneSplitOutdatedUIStore,
    hasVisitWorkInstructionAndWorkQueueUIStore,
  } = useOperationsStore()
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  if (tenantConfigStore.skipCraneSplit) return <></>

  useAsyncFetch(
    async () => {
      if (visitId) {
        await Promise.all([
          isCraneSplitOutdatedUIStore.load(visitId),
          hasVisitWorkInstructionAndWorkQueueUIStore.load(visitId),
        ])
      }
    },
    [hasVisitWorkInstructionAndWorkQueueUIStore, isCraneSplitOutdatedUIStore, visitId],
    {
      cleanUp: () => {
        isCraneSplitOutdatedUIStore.setVesselVisitId(undefined)
        hasVisitWorkInstructionAndWorkQueueUIStore.setVesselVisitId(undefined)
      },
    },
  )

  return (
    <Card sx={{ minWidth: '100%', minHeight: '100%' }}>
      <CardHeader
        action={
          <Button
            color='inherit'
            onClick={onViewClick}
            data-cy='crane-split-view-btn'
            disabled={!hasVisitWorkInstructionAndWorkQueueUIStore.hasWorkInstruction}
          >
            {t('view', 'View')}
          </Button>
        }
        title={<Typography variant='h2'>{t('craneSplit', 'Crane split')}</Typography>}
      />
      <CardContent sx={{ minHeight: '100%' }}>
        <Stack gap={1}>
          <Stack direction='row' gap={theme.customSpacing.xxl}>
            <DashboardTile
              label={t('discharge', 'Discharge')}
              value={
                equipmentsVesselVisitUIStore.dischargeCranes.length
                  ? equipmentsVesselVisitUIStore.dischargeCranes.join(', ')
                  : 0
              }
            />
            <DashboardTile
              label={t('load', 'Load')}
              value={
                equipmentsVesselVisitUIStore.loadCranes.length
                  ? equipmentsVesselVisitUIStore.loadCranes.join(', ')
                  : 0
              }
            />
          </Stack>
          {isCraneSplitOutdatedUIStore.isCraneSplitOutDated && (
            <Alert severity='warning'>
              {t(
                'craneSplitOutdatedNewOrdersHaveBeenAdded',
                'The crane split is outdated. New orders have been added.',
              )}
            </Alert>
          )}
          {!hasVisitWorkInstructionAndWorkQueueUIStore.hasWorkInstruction && (
            <Alert severity='warning'>
              {t(
                'craneSplitNotPossiblePleaseAddOrders',
                'Crane split not currently possible. Please add the orders.',
              )}
            </Alert>
          )}
        </Stack>
      </CardContent>
    </Card>
  )
})
